import { ReactNode, Suspense } from "react";

interface ISelectiveHydrationBoundaryProps {
    children: ReactNode;
}

/** Lets React hydrate this part separately from the rest of the page, yielding to user input in between. */
export const SelectiveHydrationBoundary = ({ children }: ISelectiveHydrationBoundaryProps) => <Suspense fallback={null}>{children}</Suspense>;
